import { render, staticRenderFns } from "./preevision2x.vue?vue&type=template&id=7944e34a"
import script from "./preevision2x.vue?vue&type=script&lang=js"
export * from "./preevision2x.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports